<template>
  <div>
    <booking-selected-service :showBackButton="showNavigation" />
    <v-row v-if="isLoadingSlots" style="height: 500px">
      <v-skeleton-loader
        width="100%"
        type="article, list-item-two-line, list-item-two-line,list-item-two-line, list-item-two-line"
      ></v-skeleton-loader>
    </v-row>
    <v-row v-else-if="!slotsForDay.length && date" style="height: 500px" justify="center" align="center">
      <v-card-text style="text-align: center">
        {{ $t("bookingForm.BookingSlots.noAppointments") }}
      </v-card-text>
    </v-row>
    <v-row v-else-if="!date" style="height: 500px" justify="center" align="center">
      <v-card-text style="text-align: center">
        {{ $t("bookingForm.BookingSlots.selectDate") }}
      </v-card-text>
    </v-row>
    <div style="max-height: 500px" v-else-if="!$vuetify.breakpoint.smAndDown">
      <v-virtual-scroll class="overflow-y-auto mb-4" :height="height" :item-height="itemHeight" :items="slotsForDay">
        <template v-slot:default="{ item }">
          <v-list>
            <v-list-item key="item">
              <v-btn
                v-if="item && item.start"
                block
                large
                elevation="0"
                outlined
                :color="color"
                @click="selectSlot(item)"
              >
                {{ formatSlotDate(item) }}
              </v-btn>
            </v-list-item>
          </v-list>
        </template>
      </v-virtual-scroll>
    </div>
    <div v-else class="booking-slots-mobile">
      <v-card-text class="title font-weight-bold"> {{ $t("bookingForm.BookingSlots.selectTime") }}</v-card-text>
      <div class="booking-slots-mobile-list">
        <v-list>
          <v-list-item v-for="item of slotsForDay" :key="item.start">
            <v-btn v-if="item && item.start" block elevation="0" outlined :color="color" @click="selectSlot(item)">
              {{ formatSlotDate(item) }}
            </v-btn>
          </v-list-item>
        </v-list>
      </div>
    </div>
    <booking-navigation @back="back" @forward="forward"></booking-navigation>
  </div>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { formatHoursAndMinutes } from "@/lib/utility/date-helper";
import { BookingServiceBookingViewModelGen, BookingSlotViewModelGen } from "@/services/booking/v1/data-contracts";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import BookingNavigation from "./BookingNavigation.vue";
import BookingSelectedService from "./BookingSelectedService.vue";

@Component({ components: { BookingSelectedService, BookingNavigation } })
export default class BookingSlots extends Vue {
  @Prop({ default: true })
  showNavigation!: boolean;

  back() {
    AvailabilityModule.setCalender();
  }

  forward() {
    AvailabilityModule.setForm();
  }

  get itemHeight() {
    return 55;
  }

  get height() {
    return "395";
  }

  get selectedSlot() {
    return AvailabilityModule.selectedSlot;
  }

  set selectedSlot(slot: BookingSlotViewModelGen | undefined) {
    AvailabilityModule.setSelectedSlot(slot);
  }

  get date() {
    return AvailabilityModule.date;
  }

  set date(newDate: string | null) {
    AvailabilityModule.setDate(newDate);
  }

  get isLoadingSlots() {
    return AvailabilityModule.isLoadingSlots;
  }

  set isLoadingSlots(value: boolean) {
    AvailabilityModule.setIsLoadingSlots(value);
  }

  get bookableServices(): BookingServiceBookingViewModelGen[] {
    return AvailabilityModule.paginationList;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get slotsForDay(): BookingSlotViewModelGen[] {
    if (!AvailabilityModule.slots) {
      return [];
    }

    // Slots for day should compare the hour as well
    const slotsForDay = AvailabilityModule.slots.filter((slot) => {
      return new Date(slot.start).toISOString().substring(0, 10) === this.date && new Date(slot.start) >= new Date();
    });

    return slotsForDay;
  }

  goToServiceOverview() {
    AvailabilityModule.setServices();
  }

  selectSlot(item: BookingSlotViewModelGen) {
    this.$log.debug("selectSlot", item);
    this.selectedSlot = item;
    this.$emit("select", this.selectedSlot);
    AvailabilityModule.setForm();
  }

  formatSlotDate(slot: BookingSlotViewModelGen) {
    if (slot?.start) {
      const slotTime = new Date(slot.start);
      return formatHoursAndMinutes(slotTime);
    }
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.overflow-y-auto {
  overflow: scroll;
}

.booking-slots-mobile-list {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  padding-bottom: 16px;
}

.booking-slots-mobile {
  padding-bottom: 110px;
}
</style>
